import {TextField, TextFieldProps} from '@mui/material'
import {WheelEvent, useCallback} from 'react'

export function NumericTextField(props: Omit<TextFieldProps, 'type'>) {
  const {onWheel: originalOnWheel} = props
  const onWheel = useCallback(
    (e: WheelEvent<HTMLDivElement>) => {
      // force blur event which would disable modyfying element value via mouse wheel
      ;(e.target as HTMLElement)?.blur()
      if (originalOnWheel) {
        originalOnWheel(e)
      }
    },
    [originalOnWheel]
  )
  return <TextField {...props} type="number" onWheel={onWheel} />
}
